// Re-render the calling component when the active sidebar item changes.

import { useSyncExternalStore } from 'react';
import { onNavChange } from './navHashSync';

const subscribe = (cb: () => void) => onNavChange(cb);
const getSnapshot = () => window.location.hash;

/**
 * Forces a re-render of the calling component whenever the URL hash changes
 * (sidebar selection, header nav buttons, browser back/forward). Pair with
 * `activeNavId()` to read the current item inside the component body.
 */
export function useSyncNavActive(): void {
  // Hash is the cache key; useSyncExternalStore re-renders only when it changes.
  useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
